import { render, staticRenderFns } from "./advancedSetting.vue?vue&type=template&id=35307337&scoped=true&"
import script from "./advancedSetting.vue?vue&type=script&lang=js&"
export * from "./advancedSetting.vue?vue&type=script&lang=js&"
import style0 from "./advancedSetting.vue?vue&type=style&index=0&id=35307337&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35307337",
  null
  
)

export default component.exports